export default "__VITE_ASSET__vLwSbepE__"